module.exports = __webpack_public_path__ + "img/encurtador.8f2cd026.svg";